import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Typography, Grid } from '@material-ui/core';

const GreenCheckbox = withStyles((theme) => ({
  root: {
    color: theme.palette.KenColors.neutral60,
    '&$checked': {
      color: theme.palette.KenColors.primary,
    },
  },
  checked: {},
}))((props) => <Checkbox color='default' {...props} />);

const useStyles = makeStyles((theme) => ({
  container: {
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'unset',
    },
  },
  greenCheckbox: {
    color: theme.palette.KenColors.neutral40,
    marginRight: '-20px',
  },
  greenCheckboxDisabled: {
    color: '',
    marginRight: '-20px',
  },
}));
export default function KenCheckbox(props) {
  const { disabled, name, label, value, onChange } = props;
  const classes = useStyles();

  return (
    <FormGroup disabled>
      <Grid container alignItems='center' className={classes.container}>
        <Grid item>
          <FormControlLabel
            control={
              <GreenCheckbox
                disabled={disabled}
                checked={value}
                onChange={onChange}
                name={name}
                className={
                  disabled
                    ? classes.greenCheckbox
                    : classes.greenCheckboxDisabled
                }
              />
            }
          />
        </Grid>
        <Grid item>
          <Typography> {label} </Typography>
        </Grid>
      </Grid>
    </FormGroup>
  );
}
